import styled from 'styled-components'
import EditIcon from '@mui/icons-material/Edit'

export const Container = styled.div`

`
export const Img = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 5px;
`
export const EditIconStyles = styled(EditIcon)`
  cursor: pointer;
  color: #323D5D
`
